import { setLocalJsonCache } from '@/utils/cache'
/**
 * 防抖
 */
export const _debounce = (fn) => {
  let timer
  return (...args) => {
    const context = this
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.call(context, ...args)
    }, time)
  }
}
/**
 * 节流
 */
export const _throttle = (fn, time) => {
  let activeTime = 0
  return (...args) => {
    const context = this
    const current = Date.now()
    if (current - activeTime >= time) {
      fn.call(context, ...args)
      activeTime = Date.now()
    }
  }
}
/**
 * @desc 手机号脱敏
 * @demo 155****8810  */
export const hidePhone = (phone) => {
  if (phone?.length === 11) {
    return phone.slice(0, 3) + '****' + phone.slice(7)
  } else {
    console.error('手机号码格式不正确')
    return phone
  }
}

/**
 * 格式化金额
 * @param {*} amount 金额数字
 * @returns 每四位金额用逗号隔开
 *  */
export const formattedAmount = (amount) => {
  if (!amount) {
    return '0.00'
  }
  const number = Number(amount)
  if (isNaN(number)) {
    return ''
  }
  return number.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

/**
 * 手机号是否合法
 */
export const isIphoneLegitimate = (str) => {
  const regPhone = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
  return regPhone.test(str)
}

/**
 * 银行卡号脱敏
 */
export const bankCardDesensitization = (val) => {
  if (!val) {
    return ''
  }
  return val.replace(/(\d{4})\d+(\d{4})/, '$1 **** **** $2')
}

/**
 * 获取网址后面的地址信息
 */
export const getHttpsAddress = () => {
  const Address = new URL(window.location.href).searchParams.get('promoterAddress')
  const promoterAddress = Address ? decodeURIComponent(Address) : ''
  if (promoterAddress) {
    setLocalJsonCache('promoterAddress', promoterAddress)
  }
  return promoterAddress
}
